import Vue from "vue";

const state = {
  brands: [],
  brand: {},
  totalBrands: 0
};

const getters = {};

const actions = {
  LOAD_BRAND: async function({ commit }, payload) {
    return Vue.prototype.$axios
      .get("/products/brands/" + payload.productBrandId)
      .then(response => {
        commit("SET_BRAND", response.data.productBrand);
      });
  },
  LOAD_BRANDS: function({ commit, rootState }, payload) {
    let idQuery = payload.id ? "&id=" + payload.id.trim() : "";
    let brandNameQuery = payload.name ? "&name=" + payload.name.trim() : "";

    return Vue.prototype.$axios
      .get(
        "/products/brands?from=" +
          payload.from +
          "&limit=" +
          payload.to +
          idQuery +
          brandNameQuery
      )
      .then(
        response => {
          commit("SET_BRANDS", response.data.productBrands);
          commit("SET_TOTAL_BRANDS", response.data.meta.total);
          return response;
        },
        err => {
          throw new Error(err);
        }
      );
  },
  CREATE_BRAND: async function({ commit }, payload) {
    return await Vue.prototype.$axios
      .post("/products/brands", payload, {
        Headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(
        response => {
          return response;
        },
        err => {
          throw new Error(err);
        }
      );
  },
  UPDATE_BRAND: async function({ commit }, payload) {
    return await Vue.prototype.$axios
      .post("/products/brands/" + payload.id, payload, {
        Headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(
        response => {
          return response;
        },
        err => {
          throw new Error(err);
        }
      );
  },
  DESTROY_BRAND: async function({ commit }, payload) {
    return await Vue.prototype.$axios.delete("products/brands/" + payload).then(
      response => {
        return response;
      },
      err => {
        throw new Error(err);
      }
    );
  }
};

const mutations = {
  SET_BRANDS: (state, brands) => {
    state.brands = brands;
  },
  SET_TOTAL_BRANDS: (state, totalBrands) => {
    state.totalBrands = totalBrands;
  },
  SET_BRAND: (state, payload) => {
    state.brand = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
